import {  For, Show } from 'solid-js';
import { Component } from 'Shared/frontend/widgets/Component';
import { css, cx } from '@emotion/css';
import { theme } from 'Shared/frontend/SettingsProvider';
import { StylesProvider, useStylePath, useStyleDetails } from 'Shared/frontend/widgets/StylesProvider';

const sectionStyle = (isFirst:boolean,isLast:boolean) => css(theme().section,{
//TODO probably move these into theme().section...
	width: '100%',
	marginTop: isFirst ? 0 : '4em',
	marginBottom: isLast ? '2em' : '4em',
});

const buttonsStyle = () => css({
	display: 'contents',
});


export function LayoutComponents(P)
{
	const styleDetails = useStyleDetails();
	const stylePath = useStylePath();

	return (
		<For each={P.layout}>{(section,index) =>
			<Show when={!section.disable}>
				<StylesProvider path={stylePath} styleDetails={styleDetails}>
					<section 
						id={`widget${index()}`} 
						class={cx(
							sectionStyle(index()==0,index()==P.layout.length-1),
							section.layout == 'buttons' && buttonsStyle()
						)}
					>
						<Component {...section} index={index()} />
					</section>
				</StylesProvider>
			</Show>
		}</For>
	);
}

